module.exports = __webpack_public_path__ + "img/jiegou.0feeebbd.png";